import { localStorageKeyPrefix } from '@previo/core'

enum LocalStorageKeys {
  AUTHORIZATION = 'authorization',
  REDIRECT = 'redirect',
  DEVICE_UD = 'device-id',
}

class LocalStorageKeyManager {
  private static prefix = localStorageKeyPrefix()

  static createStorageKey(key: LocalStorageKeys): string {
    return this.prefix + key
  }
}

export { LocalStorageKeys, LocalStorageKeyManager }
